import { Component } from "react";

export abstract class DynamicSection<P, S> extends Component<P, S> {
  abstract componentDidMount: () => Promise<void>;
  abstract getItemsFromServerAndSaveToState: () => Promise<void>;
}
